import { useAuth } from "@/contexts/AuthContext";
import CreateOrganizationForm from "@/components/CreateOrganizationForm";
import { OrganizationSwitcher } from "@/components/OrganizationSwitcher";

export default function CreateOrganization() {
  // App shows this page only while the selected organization is the incomplete one
  const { selectedOrganization: organization, user } = useAuth();

  // Parse displayName for default first/last name
  const displayName = user?.displayName || "";
  const nameParts = displayName.split(" ");
  const defaultFirstName = nameParts[0] || "";
  const defaultLastName = nameParts.slice(1).join(" ") || "";

  if (!organization) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
        <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-lg shadow">
          <h1 className="text-2xl font-semibold text-center">Error</h1>
          <p className="text-muted-foreground text-center">
            No organization found. Please contact support.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-lg shadow">
        {/* A member of several orgs can leave the unnamed one instead of completing it */}
        <OrganizationSwitcher className="ml-auto" />
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-center">Complete Your Organization Setup</h1>
          <p className="text-muted-foreground text-center">
            Welcome! Let's finish setting up your organization so you can start managing your field trials.
          </p>
        </div>

        <CreateOrganizationForm
          organizationId={organization.id!}
          currentEmail={organization.email || ""}
          defaultFirstName={defaultFirstName}
          defaultLastName={defaultLastName}
        />
      </div>
    </div>
  );
}
